module.exports = __webpack_public_path__ + "static/media/sale-icon4.ba302007.svg";